import { createContext, useContext } from 'react';
const defaultValue = {
  onCloseAnimationComplete: () => {},
  isAnimationReady: false
};
export const SideDockContext = /*#__PURE__*/createContext(defaultValue);
export const useSideDockContext = () => useContext(SideDockContext);